import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackBlackFridayBannerClick, trackBlackFridayBannerShow } from './tracking';
import { BlackFridayBanner } from '../../components/BlackFridayBanner';
import { selectBlackFriday } from '../../selectors/blackFriday';
import { selectCurrentRegion } from '../../selectors/currentRegion';
import { selectHasBlackFridayOffers } from '../../selectors/promosPage';
import { getBlackFridayRegionedUrl } from '../../utils/urls';

export const BlackFridayBannerContainer: React.FC = () => {
  const { banner } = useSelector(selectBlackFriday);
  const currentRegion = useSelector(selectCurrentRegion);
  const hasBlackFridayOffers = useSelector(selectHasBlackFridayOffers);

  if (!banner || !hasBlackFridayOffers) {
    return null;
  }

  const { background, buttonText, buttonTheme, labels, subtitle, textColor, title, url } = banner;

  return (
    <BlackFridayBanner
      background={background}
      buttonText={buttonText}
      buttonTheme={buttonTheme}
      labels={labels}
      subtitle={subtitle}
      textColor={textColor}
      title={title}
      url={getBlackFridayRegionedUrl(url, currentRegion)}
      onClick={trackBlackFridayBannerClick}
      onShow={trackBlackFridayBannerShow}
    />
  );
};
